mutation AddMetadataField($campaignId: ID!, $name: String!) {
    addMetadataField(campaignId: $campaignId, name: $name) {
        _id
        name
    }
}
